module.exports = __webpack_public_path__ + "static/media/partner-sample.400a490c.png";


//////////////////
// WEBPACK FOOTER
// ./src/presentation/assets/img/partner-sample.png
// module id = 549
// module chunks = 0